module.exports = __webpack_public_path__ + "img/Illustration.0c406baf.png";